import axios from 'axios';
import Vue from 'vue';

new Vue({
    data() {
        return {
            contact: {},
            exception: null,
            message: null,
            sending: false,
        };
    },

    methods: {
        send() {
            this.exception = false;
            this.message = false;
            this.sending = true;

            axios.post('/api/contacts', this.contact).then(response => {
                this.contact = {};
                this.message = response.data.message;
            }).catch(exception => {
                this.exception = exception.response.data;
            }).finally(() => {
                this.sending = false;
            });
        }
    }
}).$mount('#main');
